// Hero.js
import React from 'react';
import LazyImage from '../LazyImage/LazyImage';
import './Hero.css';

const Hero = ({ title, description, image }) => {
  return (
    <section className="hero" aria-label="Hero Section">
      <div className="hero-content">
        <div className="hero-text">
          <h1>{title}</h1>
          {description.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
        <div className="hero-image">
          <LazyImage
            src={image}
            alt="Sentmo Trading Sentiment Analyse - Vereinfachen Sie Ihr Trading"
            width="400"
            height="400"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
